import ModalMobile from "../../../../components/shared/Modal/ModalMobile";
import React, { useEffect, useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import {
  listOfSubscriptionNames,
  plansEnvConfig,
} from "../../../../common/envConfig";

export default function WarningModalForExpired({
  isOpen,
  onCancel,
  onConfirm,
  addOn,
  selectedPlan,
}) {
  const isNewSubMonthly = selectedPlan?.includes("monthly");

  return (
    <ModalMobile
      className="pt-12 font-manrope w-full max-w-[620px]"
      isOpen={isOpen}
      onClose={onCancel}
      showClose={true}
    >
      <div className="px-6">
        <div className="flex items-center gap-2">
          <div className="size-6 min-w-6 flex items-center justify-center bg-primary100 p-1.5 rounded-full">
            <FiArrowUpRight className="w-full text-primary600" />
          </div>
          <p className="text-black text-lg font-semibold">New plan</p>
        </div>

        <div className="mt-3 text-gray600 text-sm">
          You’ve selected the{" "}
          <span className="font-bold">
            {listOfSubscriptionNames[selectedPlan]}
          </span>
          , billed {isNewSubMonthly ? "monthly" : "yearly"} at $
          {plansEnvConfig[selectedPlan] +
            (addOn ? (isNewSubMonthly ? 40 : 400) : 0)}{" "}
          per {isNewSubMonthly ? "month" : "year"}
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 p-6">
        <button
          onClick={onCancel}
          className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnGray100"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500"
        >
          Continue to payment details
        </button>
      </div>
    </ModalMobile>
  );
}
